export default __webpack_public_path__ + "static/media/Helm of the Primal Spirit.70995adb.jpg";